import GlobalRequest from '../global_request'

const Request = {...GlobalRequest}

Request.baseURL = process.env.VUE_APP_BASE_URL+'simcard/'
Request.headers = {}

export default Request
